exports.url = 'https://micro-srv-mgr.yintech.net';
exports.plusServer = '/plus-server';



// WEBPACK FOOTER //
// ./src/util/config/prod.js